import { html, utl_renderObjects, utl_fadeIn } from "../base/_utils";
import { staff } from "../data/_staff";
import staffCard from "../components/templates/_staff-card";

utl_renderObjects({
    data: staff,
    template: (member) => html`<div class="col-sm-6 col-lg-4 col-xl-3 text-center mb-5">${staffCard(member, "../")}</div>`,
    target: "#staffContainer",
});

utl_fadeIn();
